module.exports = __webpack_public_path__ + "static/img/A (34).96c22fec.png";